"use client";
import { Box, Typography } from "@mui/material";
import Link from "next/link";
import { usePathname } from "next/navigation";

const Footer = ({ className }: { className?: string }) => {
  const pathname = usePathname();
  const isRewardsPage = pathname?.includes("/rewards");
  const isReferralPage = pathname?.includes("/referral");

  return (
    <Box
      component="footer"
      sx={{
        p: 1,
        position: "relative",
        zIndex: 1,
      }}
      className={className}
    >
      {isReferralPage ? (
        <>
          <Typography variant="body2" color="text.secondary">
            Offer valid for Immutable Play accounts only. Each account receives
            one permanent invite code. Referees must never have entered a Weekly
            Draw, recorded an invite code, or acted as a referrer before. Once
            the Referees qualify and enter their first Weekly Draw, referrers
            are eligible for their reward.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            The referee's first entry is free; both bonuses are credited through
            the Weekly Draw. Duplicate, circular, or self-referrals, and
            accounts flagged for terms of service violations, are ineligible for
            rewards.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <Link
              href="https://www.immutable.com/terms/immutable-play-referral-promotion"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms and Conditions apply.
            </Link>{" "}
            NO PURCHASE IS NECESSARY TO ENTER OR TO RECEIVE A REWARD. A PURCHASE
            DOES NOT INCREASE THE CHANCE OF RECEIVING A REWARD. The promotion is
            open worldwide to eligible entrants aged 18+. Where prohibited by
            law in a country or region, this promotion is void and not available
            to residents of that country or region; such residents are
            ineligible and rewards cannot be received.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            This promotion is sponsored and promoted by the IMX Ecosystem
            Foundation and operated by Immutable Play.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            These{" "}
            <Link
              href="https://www.immutable.com/terms/terms-of-service"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms and Service
            </Link>{" "}
            govern your use of the platform and its services. For details on how
            your personal information is handled, please see our{" "}
            <Link
              href="https://www.immutable.com/terms/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </Link>
          </Typography>
        </>
      ) : isRewardsPage ? (
        // Rewards-specific footer content
        <>
          <Typography variant="body2" color="text.secondary">
            <Link
              href="https://www.immutable.com/terms/perpetual-rewards-terms"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms and Conditions apply.
            </Link>{" "}
            NO PURCHASE IS NECESSARY TO ENTER OR TO RECEIVE A REWARD. A PURCHASE
            DOES NOT INCREASE THE CHANCE OF RECEIVING A REWARD. The promotion is
            open worldwide to eligible entrants aged 18+. Where prohibited by
            law in a country or region, this promotion is void and not available
            to residents of that country or region; such residents are
            ineligible and rewards cannot be received. <br />
            This promotion is sponsored and promoted by the IMX Ecosystem
            Foundation and operated by Immutable Play.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            These{" "}
            <Link
              href="https://www.immutable.com/terms/terms-of-service"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms and Service
            </Link>{" "}
            govern your use of the platform and its services. For details on how
            your personal information is handled, please see our{" "}
            <Link
              href="https://www.immutable.com/terms/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </Link>
          </Typography>
        </>
      ) : (
        <Typography variant="body2" color="text.secondary">
          Use of this site constitutes acceptance of our{" "}
          <Link
            href="https://www.immutable.com/terms/terms-of-service"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms and Service
          </Link>{" "}
          and acknowledgment of our{" "}
          <Link
            href="https://www.immutable.com/terms/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </Link>
          .
        </Typography>
      )}
    </Box>
  );
};

export default Footer;
